import cx from 'classnames'

import { IconButton } from '../../../actions/iconButton/IconButton'
import { useTranslate } from '../../../hooks'

type Props = {
  isDisabled: boolean
  variant: 'previous' | 'next'
}

export const CalendarHeaderButton = ({ isDisabled, variant }: Props) => {
  const translate = useTranslate()

  const tip = variant === 'previous' ? translate('previous') : translate('next')

  return (
    <IconButton
      slot={variant}
      iconSize="md"
      tip={isDisabled ? null : tip}
      iconName={variant === 'previous' ? 'ChevronLeft' : 'ChevronRight'}
      disabled={isDisabled}
      className={cx(
        'text-amaze-ink!',
        !isDisabled && 'hover:bg-primary-500/10! active:bg-primary-500/20!',
      )}
    />
  )
}
